import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { faLanguage } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons'

function DescriptionTemplate({
    heading,
    desc,
    paraText,
    paraText2,
    subHeading
}) {
    const createObserver = (ref, setIsVisible) => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.3 }
        );
        return observer
    };

    const observeRef = (ref, observer) => {
        if (ref.current) {
            observer.observe(ref.current);
        }
    };

    const [isVisible, setIsVisible] = useState(false);
    const missionRef = useRef(null);

    useEffect(() => {
        const observer = createObserver(missionRef, setIsVisible);

        observeRef(missionRef, observer);

        if (missionRef.current) {
            observer.observe(missionRef.current);
        }

    }, [missionRef]);

    return (
        <>
            <div ref={missionRef} className='py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24 flex flex-col items-center'>
                <div className='w-full flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12'>
                    <div className='w-full lg:w-1/2'>
                        <h1 className={`text-2xl sm:text-3xl md:text-4xl mb-3 font-thin transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
                            {subHeading}
                        </h1>
                        <h2 className={`text-sm sm:text-base font-semibold mb-4 text-gray-800 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
                            {desc}
                        </h2>
                        <div className={`text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed space-y-4 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
                            <p>{paraText}</p>
                            {paraText2 && <p>{paraText2}</p>}
                        </div>
                    </div>
                    <div className={`w-full lg:w-1/2 transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} >
                        <div className='grid grid-cols-2 gap-3 sm:gap-6 my-4'>
                            <div className="flex items-center border-b pb-3" style={{ borderColor: "#4B6587" }}>
                                <FontAwesomeIcon className='text-2xl sm:text-3xl md:text-4xl text-bluColor flex-shrink-0' icon={faCreditCard} />
                                <div className='ml-2 sm:ml-4'>
                                    <div className='text-sm sm:text-base md:text-lg font-bold text-gray-900'>20 BILLION</div>
                                    <div className='text-xs text-gray-600'>Total Value</div>
                                </div>
                            </div>
                            <div className="flex items-center border-b pb-3" style={{ borderColor: "#4B6587" }}>
                                <FontAwesomeIcon className='text-2xl sm:text-3xl md:text-4xl text-bluColor flex-shrink-0' icon={faLanguage} />
                                <div className='ml-2 sm:ml-4'>
                                    <div className='text-sm sm:text-base md:text-lg font-bold text-gray-900'>20 +</div>
                                    <div className='text-xs text-gray-600'>Language Spoken</div>
                                </div>
                            </div>
                            <div className="flex items-center border-b pb-3" style={{ borderColor: "#4B6587" }}>
                                <FontAwesomeIcon className='text-2xl sm:text-3xl md:text-4xl text-bluColor flex-shrink-0' icon={faUser} />
                                <div className='ml-2 sm:ml-4'>
                                    <div className='text-sm sm:text-base md:text-lg font-bold text-gray-900'>4.9/5</div>
                                    <div className='text-xs text-gray-600'>Customer Rating</div>
                                </div>
                            </div>
                            <div className="flex items-center border-b pb-3" style={{ borderColor: "#4B6587" }}>
                                <FontAwesomeIcon className='text-2xl sm:text-3xl md:text-4xl text-bluColor flex-shrink-0' icon={faHouse} />
                                <div className='ml-2 sm:ml-4'>
                                    <div className='text-sm sm:text-base md:text-lg font-bold text-gray-900'>5000+</div>
                                    <div className='text-xs text-gray-600'>Properties Sold</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DescriptionTemplate